import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Index from './pages/Index';
import Commander from './pages/Commander';
import Confirmation from './pages/Confirmation';
import ConditionsGenerales from './pages/ConditionsGenerales';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/commander" element={<Commander />} />
        <Route path="/confirmation" element={<Confirmation />} />
        <Route path="/conditions-generales" element={<ConditionsGenerales />} />
      </Routes>
    </Router>
  );
}

export default App;
